export default __webpack_public_path__ + "assets/img/ict-eraser.816489cc50e862e0549513cccee5c148.svg";